// @flow
import {
  GynaecIcon,
  OrthopedicDepIcon,
  CardiologyDepIcon,
  Lungs,
  HairTreatmentIcon,
  Dental,
  Fat,
  Cosmetic,
  CancerTreatmentIcon,
  HepatologyTreatmentIcon,
  IvfTreatmentIcon,
  SpineTreatmentIcon,
  UrologyTreatmentIcon,
  NeuroTreatmentIcon,
  EntTreatmentIcon,
  EyeTreatmentIcon,
  HematologyTreatmentIcon
} from '@images/svg/index';
import type { PropsIllnessFlow, PropsFlowButton } from './types';

export const BUTTONS = ({ t }: PropsIllnessFlow): Array<PropsFlowButton> => [
  {
    label: t('Illness.bone_marrow'),
    icon: HematologyTreatmentIcon,
    value: 'hematology'
  },
  { label: t('Illness.cancer'), icon: CancerTreatmentIcon, value: 'oncology_and_oncosurgery' },
  {
    label: t('Illness.hair'),
    icon: HairTreatmentIcon,
    value: 'hair_treatment'
  },
  { label: t('Illness.dental'), icon: Dental, value: 'dental_treatment' },
  {
    label: t('Illness.otho'),
    icon: OrthopedicDepIcon,
    value: 'orthopedics'
  },
  { label: t('Illness.spine'), icon: SpineTreatmentIcon, value: 'spine_surgery' },
  { label: t('Illness.liver'), icon: HepatologyTreatmentIcon, value: 'hepatology' },
  {
    label: t('Illness.kidney'),
    icon: UrologyTreatmentIcon,
    value: 'urology_treatment'
  },
  {
    label: t('Illness.cosmetic'),
    icon: Cosmetic,
    value: 'cosmetic_and_plastic_surgery'
  },
  {
    label: t('Illness.fertility'),
    icon: IvfTreatmentIcon,
    value: 'ivf_and_infertility'
  },
  {
    label: t('Illness.heart'),
    icon: CardiologyDepIcon,
    value: 'cardiology_and_cardiac_surgery'
  },
  {
    label: t('Illness.ent'),
    icon: EntTreatmentIcon,
    value: 'ent_surgery'
  },
  {
    label: t('Illness.gynae'),
    icon: GynaecIcon,
    value: 'gynecology'
  },
  {
    label: t('Illness.eye'),
    icon: EyeTreatmentIcon,
    value: 'opthalmology'
  },
  {
    label: t('Illness.brain'),
    icon: NeuroTreatmentIcon,
    value: 'neurology_and_neurosurgery'
  },
  { label: t('Illness.pulmonology'), icon: Lungs, value: 'pulmonology' },
  { label: t('Illness.obesity'), icon: Fat, value: 'obesity_or_bariatric_surgery' },
];
